// extracted by mini-css-extract-plugin
module.exports = {"Main":"_2mhed3MD","fullHeight":"_1OPr4yyl","whiteCanvas":"_3ejrEfac","blackCanvas":"_YNKxilR","overflowScrolling":"r7N60Co7","canvasFooter":"_1lhb2nVv","canvasContent":"_4H24oKF_","canvasContentPrint":"_2iQSWBBS","canvasContentApplyNow":"_2v6VCQE-","unsupportedContainer":"_132TSJa6","unsupported":"_14YDTh58"};
    if(module.hot) {
      // 1754514918480
      var cssReload = require("!../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  